/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { AxiosHttpRequest } from './core/AxiosHttpRequest';

import { AuthService } from './services/AuthService';
import { BankService } from './services/BankService';
import { BusinessAreaService } from './services/BusinessAreaService';
import { ColourService } from './services/ColourService';
import { CustomerService } from './services/CustomerService';
import { ImportService } from './services/ImportService';
import { MerkService } from './services/MerkService';
import { ProductService } from './services/ProductService';
import { ProductArticleService } from './services/ProductArticleService';
import { ProductCategoryService } from './services/ProductCategoryService';
import { ReportService } from './services/ReportService';
import { SalesService } from './services/SalesService';
import { StoreService } from './services/StoreService';
import { TeamService } from './services/TeamService';
import { TransactionService } from './services/TransactionService';
import { UnitOfMeasurementService } from './services/UnitOfMeasurementService';
import { UserService } from './services/UserService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class AppClient {

    public readonly auth: AuthService;
    public readonly bank: BankService;
    public readonly businessArea: BusinessAreaService;
    public readonly colour: ColourService;
    public readonly customer: CustomerService;
    public readonly import: ImportService;
    public readonly merk: MerkService;
    public readonly product: ProductService;
    public readonly productArticle: ProductArticleService;
    public readonly productCategory: ProductCategoryService;
    public readonly report: ReportService;
    public readonly sales: SalesService;
    public readonly store: StoreService;
    public readonly team: TeamService;
    public readonly transaction: TransactionService;
    public readonly unitOfMeasurement: UnitOfMeasurementService;
    public readonly user: UserService;

    public readonly request: BaseHttpRequest;

    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? 'https://api.store-ardiles.com/api',
            VERSION: config?.VERSION ?? '1.0.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });

        this.auth = new AuthService(this.request);
        this.bank = new BankService(this.request);
        this.businessArea = new BusinessAreaService(this.request);
        this.colour = new ColourService(this.request);
        this.customer = new CustomerService(this.request);
        this.import = new ImportService(this.request);
        this.merk = new MerkService(this.request);
        this.product = new ProductService(this.request);
        this.productArticle = new ProductArticleService(this.request);
        this.productCategory = new ProductCategoryService(this.request);
        this.report = new ReportService(this.request);
        this.sales = new SalesService(this.request);
        this.store = new StoreService(this.request);
        this.team = new TeamService(this.request);
        this.transaction = new TransactionService(this.request);
        this.unitOfMeasurement = new UnitOfMeasurementService(this.request);
        this.user = new UserService(this.request);
    }
}

